<template>
  <v-layout column>

    <h2>Saúde da criança</h2>
    <h3 class="text-secondary">Child´s health</h3>

    <v-select
      :items="bloodTypes"
      outline
      item-text="name"
      item-value="id"
      :disabled="!bloodTypes.length"
      :loading="!bloodTypes.length"
      v-model="resource.form.blood_type_id"
      label="TIPO SANGUÍNEO / BLOOD TYPE"
    />

    <v-textarea
      outline
      v-model="resource.form.birth_details"
      label="NASCEU DE PARTO NORMAL? FAVOR DESCREVER SE HOUVE ALGUMA COMPLICAÇÃO NO PARTO OU NOS MESES SEGUINTES. / DID YOU HAVE A NORMAL DELIVERY? PLEASE DESCRIBE IF THERE WERE COMPLICATIONS AT THE BIRTH OR FOLLOWED MONTHS."
      placeholder="NASCEU DE PARTO NORMAL? FAVOR DESCREVER SE HOUVE ALGUMA COMPLICAÇÃO NO PARTO OU NOS MESES SEGUINTES. / DID YOU HAVE A NORMAL DELIVERY? PLEASE DESCRIBE IF THERE WERE COMPLICATIONS AT THE BIRTH OR FOLLOWED MONTHS."
    />

    <v-textarea
      outline
      v-model="resource.form.birth_deseases"
      label="A CRIANÇA NASCEU COM ALGUM TIPO DE DOENÇA (CONGÊNITA)? QUAL? / DOES YOUR CHILD HAVE A CONGENITAL MEDICAL CONDITION? DESCRIBE."
      placeholder="A CRIANÇA NASCEU COM ALGUM TIPO DE DOENÇA (CONGÊNITA)? QUAL? / DOES YOUR CHILD HAVE A CONGENITAL MEDICAL CONDITION? DESCRIBE."
    />

    <v-textarea
      outline
      v-model="resource.form.current_deseases_details"
      label="TEM ALGUM PROBLEMA DE SAÚDE ATUALMENTE? QUAL? / DOES YOUR CHILD HAVE A MEDICAL CONDITION? DESCRIBE AND INDICATE BELOW."
      placeholder="TEM ALGUM PROBLEMA DE SAÚDE ATUALMENTE? QUAL? / DOES YOUR CHILD HAVE A MEDICAL CONDITION? DESCRIBE AND INDICATE BELOW."
    />

    <v-textarea
      outline
      v-model="resource.form.medicine_usage"
      label="FAZ USO DE ALGUM MEDICAMENTO? ESTÁ SOB ALGUM TRATAMENTO MÉDICO NO MOMENTO? DESCREVA. / WHAT MEDICATIONS DOES YOUR CHILD TAKE? IS HE/SHE UNDER A DOCTORS CARE FOR ANY CONDITION? DESCRIBE."
      placeholder="FAZ USO DE ALGUM MEDICAMENTO? ESTÁ SOB ALGUM TRATAMENTO MÉDICO NO MOMENTO? DESCREVA. / WHAT MEDICATIONS DOES YOUR CHILD TAKE? IS HE/SHE UNDER A DOCTORS CARE FOR ANY CONDITION? DESCRIBE."
    />

    <h3>TEM PRESSÃO ALTA? / HIGH BLOOD PRESSURE?</h3>
    <v-radio-group v-model="resource.form.has_high_blood_pressure" row>
      <v-radio label="SIM/YES" :value="true"></v-radio>
      <v-radio label="NÃO/NO" :value="false"></v-radio>
    </v-radio-group>

    <h3>TTEM PROBLEMAS DE AUDIÇÃO? / HEARING PROBLEMS?</h3>
    <v-radio-group v-model="resource.form.has_hearing_problems" row>
      <v-radio label="SIM/YES" :value="true"></v-radio>
      <v-radio label="NÃO/NO" :value="false"></v-radio>
    </v-radio-group>

    <h3>É EPILÉTICO? / EPILEPSY?</h3>
    <v-radio-group v-model="resource.form.has_epilepsy" row>
      <v-radio label="SIM/YES" :value="true"></v-radio>
      <v-radio label="NÃO/NO" :value="false"></v-radio>
    </v-radio-group>

    <h3>É DIABÉTICO? / DIABETES?</h3>
    <v-radio-group v-model="resource.form.has_diabetes" row>
      <v-radio label="SIM/YES" :value="true"></v-radio>
      <v-radio label="NÃO/NO" :value="false"></v-radio>
    </v-radio-group>

    <h3>É HEMOFÍLICO? / HEMOPHILIAC?</h3>
    <v-radio-group v-model="resource.form.is_hemophiliac" row>
      <v-radio label="SIM/YES" :value="true"></v-radio>
      <v-radio label="NÃO/NO" :value="false"></v-radio>
    </v-radio-group>

    <h3>TEM ALERGIAS? / ALERGIES?</h3>
    <v-layout row align-center>
      <v-radio-group v-model="resource.form.has_alergies" row>
        <v-radio label="SIM/YES" :value="true"></v-radio>
        <v-radio label="NÃO/NO" :value="false"></v-radio>
      </v-radio-group>

      <v-flex d-flex xs12 sm6 md6>
        <v-text-field
          outline
          :disabled="!resource.form.has_alergies"
          v-model="resource.form.alergie_details"
          :rules="resource.form.has_alergies ? required : []"
          :background-color="resource.form.has_alergies ? '' : '#ccc'"
          label="QUAL ? / WHAT TYPE?"
        />
      </v-flex>
    </v-layout>

    <h3>TEM PROBLEMAS DE VISÃO? / VISION PROBLEMS?</h3>
    <v-layout row align-center>
      <v-radio-group v-model="resource.form.has_vision_problems" row>
        <v-radio label="SIM/YES" :value="true"></v-radio>
        <v-radio label="NÃO/NO" :value="false"></v-radio>
      </v-radio-group>

      <v-flex d-flex xs12 sm6 md6>
        <v-text-field
          outline
          :disabled="!resource.form.has_vision_problems"
          v-model="resource.form.vision_problems_details"
          :rules="resource.form.has_vision_problems ? required : []"
          :background-color="resource.form.has_vision_problems ? '' : '#ccc'"
          label="QUAL ? / WHAT TYPE?"
        />
      </v-flex>
    </v-layout>

    <h3>É DEPENDENTE DE INSULINA? / DOES HE/SHE NEED INSULIN INJECTIONS?</h3>
    <v-radio-group v-model="resource.form.is_insulin_dependent" row>
      <v-radio label="SIM/YES" :value="true"></v-radio>
      <v-radio label="NÃO/NO" :value="false"></v-radio>
    </v-radio-group>

    <h3>É TRATADO EXCLUSIVAMENTE COM HOMEOPATIA OU ALOPATIA? / IS YOUR CHILD TREATED EXCLUSIVELY BY AN HOMEOPATHIC (MEDICAL) DOCTOR OR ALLOPATHIC DOCTOR?</h3>
    <v-radio-group v-model="resource.form.just_allopathy_or_homeopathy" row>
      <v-radio label="SIM/YES" :value="true"></v-radio>
      <v-radio label="NÃO/NO" :value="false"></v-radio>
    </v-radio-group>

    <h3>JÁ ESTEVE SOB TRATAMENTO MÉDICO OU PSICOLÓGICO? / IS YOUR CHILD BEING TREATED FOR A MEDICAL OR PSYCHOLOGICAL CONDITION?</h3>
    <v-radio-group v-model="resource.form.have_been_under_medical_treatment" row>
      <v-radio label="SIM/YES" :value="true"></v-radio>
      <v-radio label="NÃO/NO" :value="false"></v-radio>
    </v-radio-group>

    <h3>ALGUMA RESTRIÇÃO ALIMENTAR? / DOES HE/SHE HAVE FOOD RESTRICTION?</h3>
    <v-layout row align-center>

      <v-layout row>
        <v-radio-group v-model="resource.form.has_food_restrictions" row wrap>
          <v-radio label="SIM/YES" :value="true"></v-radio>
          <v-radio label="NÃO/NO" :value="false"></v-radio>
        </v-radio-group>
      </v-layout>

      <v-flex d-flex xs12 sm6 md6>
        <v-text-field
          outline
          :disabled="!resource.form.has_food_restrictions"
          v-model="resource.form.food_restriction_details"
          :rules="resource.form.has_food_restrictions ? required : []"
          :background-color="resource.form.has_food_restrictions ? '' : '#ccc'"
          label="QUAL ? / WHAT TYPE?"
        />
      </v-flex>
    </v-layout>

    <v-text-field
      outline
      v-model="resource.form.food_preference"
      label="ALGUMA PREFERÊNCIA ALIMENTAR? / ANY FOOD PREFERENCE?"
    />

    <h3>JÁ FOI SUBMETIDO À ALGUMA CIRURGIA? / HAS HE/SHE HAD SURGERY?</h3>
    <v-radio-group v-model="resource.form.had_surgery" row>
      <v-radio label="SIM/YES" :value="true"></v-radio>
      <v-radio label="NÃO/NO" :value="false"></v-radio>
    </v-radio-group>

    <h3>HÁ ALGUMA VACINA EM ATRASO? / HAS YOUR CHILD HAD ALL REQUIRED VACCINATIONS?</h3>
    <v-radio-group v-model="resource.form.has_all_required_vaccinations" row>
      <v-radio label="SIM/YES" :value="true"></v-radio>
      <v-radio label="NÃO/NO" :value="false"></v-radio>
    </v-radio-group>

    <h3>APRESENTA ALGUMA DOENÇA? DOES HE/SHE HAVE A MEDICAL CONDITION?</h3>
    <v-radio-group v-model="resource.form.has_any_medical_condition" row>
      <v-radio label="SIM/YES" :value="true"></v-radio>
      <v-radio label="NÃO/NO" :value="false"></v-radio>
    </v-radio-group>

    <h3>TEM PEDIATRA? / DOES HE/SHE ATTEND A SPECIFIC PEDIATRICIAN?</h3>
    <v-radio-group v-model="resource.form.has_pediatrician" row>
      <v-radio label="SIM/YES" :value="true"></v-radio>
      <v-radio label="NÃO/NO" :value="false"></v-radio>
    </v-radio-group>

    <h3>EM CASO DE EMERGÊNCIA, PODEMOS INICIAR OS PRIMEIROS-SOCORROS NA ESCOLA? / IN AN EMERGENCY, DOES THE SCHOOL HAVE PERMISSION TO BEGIN FIRST AID PROCEDURES?</h3>
    <v-radio-group v-model="resource.form.permission_to_apply_first_aid" row>
      <v-radio label="SIM/YES" :value="true"></v-radio>
      <v-radio label="NÃO/NO" :value="false"></v-radio>
    </v-radio-group>

  </v-layout>
</template>

<script>
import * as api from '@/api'

/**
 * @group Form
 * Componente de form para dados de Saúde do estudante
 */
export default {
  name: 'FormHealth',

  data: () => ({
    bloodTypes: [],
    required: [v => !!v || 'Campo obrigatório/Field is required']
  }),

  inject: ['resource'],

  computed: {
    resource () {
      return this.resource
    }
  },

  mounted () {
    api.forms.information.getBloodType().then(response => {
      this.bloodTypes = this.computeBloodTypes(response.data)
    }).catch(error => {
      throw new Error(error)
    })
  },

  methods: {
    /**
     * @vuese
     * Metodo para modelar dados da select de tipo sanguineo
     */
    computeBloodTypes (rawData) {
      const newData = []

      rawData.map(bloodType => {
        newData.push({
          id: bloodType.id,
          name: bloodType.name
        })
      })

      return newData
    },

    /**
     * @vuese
     * Metodo para validacao da form
     */
    validateForm () {
      return this.$refs.form.validate()
    }
  }
}
</script>
